import React from 'react';

import { callApi } from 'helpers/callApi/callApi';
import { AppTable, AppTableColumn } from 'components/table/appTable';
import { NlpTranscriptEntry, NlpTranscriptTableProps, NlpTranscriptTableState } from './NlpTranscriptTable.types';

export class NlpTranscriptTable extends React.Component<NlpTranscriptTableProps, NlpTranscriptTableState> {
  columns: AppTableColumn[] = [
    {
      Header: 'Text',
      accessor: (row: NlpTranscriptEntry) => row.text,
      className: 'break-words',
      id: 'text',
    },
    {
      Header: 'Start Time',
      accessor: (row: NlpTranscriptEntry) => row.adjustedStartTime,
      className: 'break-words',
      id: 'adjustedStartTime',
    },
    {
      Header: 'End Time',
      accessor: (row: NlpTranscriptEntry) => row.adjustedEndTime,
      className: 'break-words',
      id: 'adjustedEndTime',
    },
  ];

  constructor(props: NlpTranscriptTableProps) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      error: false,
    };
  }

  componentDidMount(): void {
    this.fetchTranscript();
  }

  fetchTranscript() {
    const { fetchNlpTranscript, eventId } = this.props;

    callApi({
      action: () => {
        this.setState({ loading: true });

        return fetchNlpTranscript(eventId);
      },
      onSuccess: ({ payload }: any) => {
        const transcript = payload?.data?.transcript ?? [];
        this.setState({ data: transcript, loading: false });
      },
      onFailure: () => this.setState({ loading: false, error: true, data: [] }),
    });
  }

  render() {
    const { data, loading, error } = this.state;

    return (
      <>
        {!!data && <AppTable tableName="NlpTranscript" columns={this.columns} data={data} loading={loading} />}
        {error && <div>Something went wrong</div>}
      </>
    );
  }
}
